/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { MouseEventHandler, ReactNode } from 'react'
import PropTypes from 'prop-types'
import * as S from './Button.styled'
import { ButtonColor, ElementSizeType, successButtonColor } from '@styles/theme-const'
import { ElementSize } from 'src/shared/ui/styles/type'

const defaultProps: ButtonProps = {
    isClickable: true,
    isShadow: false,
    passHref: undefined,
    disabled: false,
    type: 'button',
    textTransform: 'none',
    colors: successButtonColor,
    elementSizeTypeValue: ElementSizeType.large as ElementSize
}

interface ButtonProps {
    isClickable?: boolean
    isShadow?: boolean
    passHref?: string
    disabled?: boolean
    textTransform?: string
    type?: 'button' | 'submit' | 'reset' | undefined
    colors?: ButtonColor
    elementSizeTypeValue?: ElementSize
    children?: ReactNode | string
    clickHandler?: React.MouseEventHandler<HTMLButtonElement>
}

const Button = (props: ButtonProps) => {
    const currentProps: ButtonProps = { ...defaultProps, ...props } as ButtonProps
    if (props.passHref) {
        // noinspection JSValidateTypes

        return (
            <S.ButtonLinkElement
                elementSizeTypeValue={currentProps!.elementSizeTypeValue!}
                isShadow={currentProps!.isShadow!}
                isClickable={currentProps!.isClickable!}
                isDisabled={currentProps!.disabled}
                textTransform={currentProps!.textTransform}
                href={currentProps?.passHref}
                colors={currentProps?.colors}
                {...currentProps}>
                {currentProps.children}
            </S.ButtonLinkElement>
        )
    }

    const clickHandler: MouseEventHandler<HTMLButtonElement> = (e) => {
        if (currentProps.clickHandler && !currentProps.disabled && currentProps.isClickable) {
            currentProps.clickHandler(e)
        }
    }

    return (
        <S.ButtonElement
            onClick={clickHandler}
            elementSizeTypeValue={currentProps?.elementSizeTypeValue as ElementSize}
            isShadow={currentProps!.isShadow!}
            isClickable={currentProps.isClickable}
            isDisabled={currentProps.disabled}
            textTransform={currentProps.textTransform}
            type={currentProps.type}
            colors={currentProps.colors}
            {...currentProps}>
            {currentProps.children}
        </S.ButtonElement>
    )
}

Button.propTypes = {
    isClickable: PropTypes.bool,
    elementSizeTypeValue: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    colors: PropTypes.shape({
        color: PropTypes.string,
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        hoverBackgroundColor: PropTypes.string,
        shadowColor: PropTypes.string,
        shadowHoverColor: PropTypes.string
    }),
    textTransform: PropTypes.string,
    passHref: PropTypes.string,
    clickHandler: PropTypes.func,
    isShadow: PropTypes.bool
}

export default Button
